
var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');
var BASE_URL = '/smt/planning-service/non-fitting-parts';

var mountedFragment = function mountedFragment() {
  this.$nextTick(function () {
    var _this = this;
    var $el = $(this.$el);
    sw.trigger('sw-fragment-loaded', $el);
    // Listen to changes in the selectric dropdown and pass it to the the Vue object method
    $el.on('selectric-change', function(e, el) {
      _this.dispatchInputEvent(el.value);
    });
  });
};

module.exports = function ($fragment) {
  $fragment.swFindWithSelf("[data-sw-neutronium-form]").each(function () {
    var $materialCheckboxes = $('[data-sw-material-checkbox]');
    var materialOptions = [];
    $materialCheckboxes.each(function () {
      var $el = $(this);
      materialOptions.push({id: $el.val(), materialFamilyId: $el.attr('data-sw-material-family')});
    });

    new Vue({
      el: this,
      data: {
        trayHeight: '',
        materialIds: [],
        printerSelect: '',
        selectAll: true
      },
      computed: {
        nonFittingUrl: function () {
          nonFittingUrl = BASE_URL + '?trayHeight=' + this.trayHeight + '&materialIds=' + this.materialIds.toString() + '&printerTraySettingId=' + this.printerSelect;
          return nonFittingUrl;
        }
      },
      mounted: mountedFragment,
      methods: {
         checkAllMaterials: function (materialFamilyId) {
           var materialsToCheck = [];
           for (var key in materialOptions) {
              if (materialOptions[key].materialFamilyId == materialFamilyId) {
                materialsToCheck.push(materialOptions[key].id);
              }
           }
           this.selectAll = false;
           this.materialIds = materialsToCheck;
           return this.materialIds;
         },
         uncheckAllMaterials: function () {
           this.selectAll = true;
           this.materialIds = [];
           return this.materialIds;
         },
        dispatchInputEvent: function dispatchInputEvent(value) {
          this.printerSelect = value;
        }
      }
    });
  });
};
